import React, { useMemo } from 'react';

function Contact() {
  const fireflies = useMemo(() => {
    const small = Array.from({ length: 20 }).map(() => {
      const top = `${Math.random() * 100}%`;
      const left = `${Math.random() * 100}%`;
      const delay = `${(Math.random() * 5).toFixed(2)}s`;
      const duration = `${(3 + Math.random() * 20).toFixed(2)}s`;
      const swirl = Math.random() > 0.6;
      return { top, left, duration, swirl, size: 1 };
    });
    const big = Array.from({ length: 5 }).map(() => {
      const top = `${Math.random() * 100}%`;
      const left = `${Math.random() * 100}%`;
      const delay = `${(Math.random() * 5).toFixed(2)}s`;
      const duration = `${(3 + Math.random() * 4).toFixed(2)}s`;
      const swirl = Math.random() > 0.6;
      return { delay, swirl, size: 2 };
    });
    return [...small, ...big];
  }, []);

  return (
    <section className="hero interior">
      <div className="container">
        <div style={{ maxWidth: '600px', margin: '100px auto 0' }}>
          {/* Contact & Substack Section */}
          <div style={{ 
            backgroundColor: 'rgba(255,255,255,0.1)', 
            borderRadius: '8px', 
            padding: '2rem',
            backdropFilter: 'blur(10px)',
            border: '1px solid rgba(255,255,255,0.2)'
          }}>
            {/* Substack Form */}
            <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
              <h2 style={{ color: '#fff', fontSize: '27px', fontWeight: '700', marginBottom: '1rem' }}>
                Subscribe to my Substack
              </h2>
              <p style={{ color: 'rgb(210, 210, 210)', fontSize: '18px' }}>
                Sign up for updates on upcoming book releases, signing events, and other writerly endeavors.<br/>
                <span style={{ fontSize: '14px', marginTop: '20px', display: 'inline-block' }}>(Also funny cat photos)</span>
              </p>
            </div>
            
            {/* Substack embed iframe */}
            <iframe 
              src="https://seandavidrobinson.substack.com/embed" 
              width="100%" 
              height="320" 
              style={{ 
                border: '1px solid rgba(255,255,255,0.2)', 
                borderRadius: '4px',
                background: 'rgba(255,255,255,0.9)'
              }} 
              frameBorder="0" 
              scrolling="no"
              title="Substack Newsletter Signup"
            ></iframe>

            {/* Contact Info */}
            <div style={{ textAlign: 'center', marginTop: '3rem' }}>
              <p style={{ color: 'rgb(210, 210, 210)', fontSize: '18px', marginBottom: '1rem' }}>
                <span style={{ color: '#fff' }}>Email: </span>
                <a href="mailto:seandavidrobinson@gmail.com" style={{ color: '#feec78', textDecoration: 'underline' }}>
                  seandavidrobinson@gmail.com
                </a>
              </p>
              <p style={{ color: 'rgb(210, 210, 210)', fontSize: '18px' }}>
                <span style={{ color: '#fff' }}>Representation: </span>
                <a href="https://knightagency.net/" target="_blank" rel="noopener noreferrer" style={{ color: '#feec78', textDecoration: 'underline' }}>
                  Travis Pennington at The Knight Agency
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>

      {fireflies.map((pos, idx) => (
        <span
          key={idx}
          className={`firefly${pos.swirl ? ' swirl' : ''}${pos.size === 8 ? ' big' : ''}`}
          style={{
            top: pos.top,
            left: pos.left,
            animationDelay: pos.delay,
            animationDuration: pos.duration,
            opacity: 0.1
          }}
        />
      ))}
    </section>
  );
}

export default Contact; 